<div class="branded-asset-header">
	<div class="container">
		<div class="row">
			<div class="col-10 col-sm-4">
				<a [routerLink]="['/fleet']" class="branded-asset-logo"></a>
			</div>
			<div class="col-sm-6 d-none d-sm-block">
				<h1>Welcome <b>{{api.user.email}}</b></h1>
				<div class="organization">{{api.user.organization_name}}</div>
			</div>
			<div class="col-2 burger-column">
				<app-hamburger-menu></app-hamburger-menu>
			</div>
		</div>
	</div>
</div>